<template>
  <div
    class="tw-flex tw-items-center tw-cursor-pointer tw-no-underline tw-font-normal tw-leading-none tw-text-gray-800"
  >
    <a v-if="activeCompany" :href="`/my-profile?company=${activeCompany.id}`">
      <UserAvatar
        :user="authUser"
        style="width: 24px; height: 24px; margin-top: 3px;"
      ></UserAvatar>
    </a>
    <UserAvatar
      v-else
      :user="authUser"
      style="width: 24px; height: 24px; margin-top: 3px;"
    ></UserAvatar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HandleAuth from '@/mixins/HandleAuth'

export default {
  name: 'UserCircle',

  mixins: [HandleAuth],
  computed: {
    ...mapGetters('auth', ['check']),
  },
}
</script>
